import GoldPriceView from 'src/sections/overview/gold-price/view/gold-price-view';

export default function GoldPrice() {
  return <GoldPriceView />;
}
